import axios from 'axios';
import sessionHelper from 'helpers/sessionHelper';

const REACT_APP_API_ROOT =
  (window._env_ && window._env_.REACT_APP_API_ROOT) ||
  process.env.REACT_APP_API_ROOT;
const REACT_APP_X_TOKEN =
  (window._env_ && window._env_.REACT_APP_X_TOKEN) ||
  process.env.REACT_APP_X_TOKEN;

axios.defaults.baseURL = `${REACT_APP_API_ROOT || '/'}`;

const authProvider = store => {
  const { startSession } = sessionHelper(store);
  axios.interceptors.request.use(
    config => {
      const xToken = REACT_APP_X_TOKEN || store.getState(store).user.xToken;
      return {
        ...config,
        headers: xToken
          ? {
              ...config.headers,
              'x-token': xToken
            }
          : config.headers
      };
    },
    error => {
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    response => {
      if (
        response.status === 200 &&
        !store.getState(store).user.refreshSession
      ) {
        startSession();
      }
      return response;
    },
    error => {
      return Promise.reject(error);
    }
  );
};

export default authProvider;
